import { render } from "./EmployeeAdvance.vue?vue&type=template&id=19999f44"
import script from "./EmployeeAdvance.vue?vue&type=script&lang=js"
export * from "./EmployeeAdvance.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\Peaco-v.1\\PEACO\\peacohrm-main\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__